
import { Component, OnInit, TemplateRef } from '@angular/core';
import { UseraddService } from './useradd.service';
import { User } from '../user/user';
import { BsModalRef, ModalOptions, BsModalService } from 'ngx-bootstrap/modal';
import { FormGroup, Validators, FormBuilder, FormArray, FormControl, ValidatorFn } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { DatabaseService } from '../database/database.service';
import { TeamMgtService } from '../../teammgt/teammgt.service';
import { TeamMgt } from '../../teammgt/teammgt';
import { DomSanitizer } from '@angular/platform-browser';
import { CommondialogComponent } from '../../Shared/commondialog/commondialog.component';
import { MenurightsComponent } from '../../Shared/menurights/menurights.component';
import { DialogService } from 'ng2-bootstrap-modal';
import { ChangeDetectorRef } from '@angular/core';
import * as $ from 'jquery'; declare let $: any;
import { CommonService } from '../../Shared/commonservice';
import { last } from 'rxjs/operators';
import { NgxSpinnerService } from "ngx-spinner";												
import { LocalService } from '../../local.service';
import { FormrenderService } from  '../../formrender/formrender.service';
import { environment } from '../../../environments/environment';
import {encryptdecrypt} from '../../encryptdecrypt';

@Component({
  selector: 'app-useradd',
  templateUrl: './useradd.component.html',
  styleUrls: ['./useradd.component.css']

})
export class UseraddComponent implements OnInit {
  sendMenuId: number = 1;
  sendPageName: string = 'User Add';
  _teamList: any = []; _teamListTmp: any = [];
  _databaseList: any = []; _databaseListTmp: any = [];
  _selectedItems: any = [];
  _requestList: any = []; _requestListTmp: any = [];
  _requestdropdownSettings: any = [];
  _requestselectedItems: any = [];
  _mappedMenuActionList: any;
  useridlogin: number;
  _dropdownSettings: any;
  _action: string;
  _userId: number;
  imagepath: any;
  _hidepassword: number;
  textBoxTocuhed: boolean;
  // actions = [{ 'action': 'View' }, { 'action': 'Add' }, { 'action': 'Edit' }, { 'action': 'Delete' }];

  actions = [];
  //formgroup
  userForm: FormGroup;
  users: User[];
  fileselect: boolean=false;
  user: User;
  title: string;
  edituser1: User;
  teams: TeamMgt[];
  team: TeamMgt;
  submitted = false;
  checkedstatus: boolean;
  loading: boolean = false;
  _accessrequestid: number;
  _selectedReviewItems: any = [];
  _requestReviewList: any = [];
  _requestreviewdropdownSettings: any = [];
  productline: any;
  _prodDropdownSettings: any;
  _selectedProductLineItems:any=[]; 
autoLogAccess:number=0;
autoLogAdmin:boolean=false;
selectedProductLineItems:any=[];
chkautoLogAccess:boolean=false;
 autologAdminId:string=environment.autologAdmin;
 apiautologinputstr:string='';
 isautologuser:boolean=false; isAutologNewuser=false;isLoggedUsrAutLog=0;
 AdminTeamId:number=environment.AdminTeamId;hideChkAutoAccess=false;
 hideChkAutoAdminAcs=false;isautologteam:number=0;isautologadmin:number=0;
 autologUserTeamId:number=environment.autologUserTeamId;
 passwordComplexity=0;
 _selectedProductLineItemsTmp:any=[];
 public barLabel: string = "Password strength:";
 public account = {  
       password: null  
     }; 
  constructor(
    private router: Router,
    private toastr: ToastrService,
	private SpinnerService: NgxSpinnerService,											
    private menucomp: MenurightsComponent,
    private _sanitizer: DomSanitizer,
    private databaseService: DatabaseService,
    private formBuilder: FormBuilder,
    private UseraddService: UseraddService,
    private teamService: TeamMgtService,
    private route: ActivatedRoute,
    private cdref: ChangeDetectorRef,
    private dialogService: DialogService,
    private commonService: CommonService,
    private localService: LocalService,
    private formRenderService: FormrenderService
  ) {
    this._userId = +this.route.snapshot.queryParamMap.get('userid');
   this.isLoggedUsrAutLog= +this.localService.getJsonValue("isautologuseronly");
  this.isautologteam=+ this.localService.getJsonValue('isautologteam');  
   this.isautologadmin=+this.localService.getJsonValue('isautologadmin');
  
  }



  ngOnInit() {
    this.userForm = this.formBuilder.group({
      userid: [''],
      //firstname: ['', [Validators.required, Validators.pattern('^(?=.*[a-zA-Z])[a-zA-Z0-9]+$')]],
      //lastname: ['', [Validators.required, Validators.pattern('^(?=.*[a-zA-Z])[a-zA-Z0-9]+$')]],
      //emailid: ['', [Validators.required, Validators.email]],
      //password: ['', [Validators.required]],
      //teamid: [''],
      //usertype:[''],
      //databasemapped: [''],
      //menumapped: [''],

      firstname: ['', [Validators.required]],
      lastname: ['', [Validators.required]],
      emailid: ['', [Validators.required, Validators.email]],
      // password: ['', [Validators.required]],
      teamid: ['', [Validators.required]],
      singlesignon: ['', [Validators.required]],
      userrole: [0, [Validators.required]],
      // firstname: [''],
      //lastname: [''],
      //emailid: [''],
      password: [''],
      //teamid: [''],
      //singlesignon: [''],
      databasemapped: [''],
      requestmapped: [''],
      menumapped: [''],
      comment: [''],
      ImgFile: [''],
      productline:[''],
      actions: new FormArray([]), reviewmapped: []
      //actions: new FormArray([], minSelectedCheckboxes(0))
    });

    this._selectedItems = [];
    this.LoadExisitingTeamList();
    this.LoadExisitingDatabaseList();
    this.LoadExisitingRequestTypeList();
    this.loadproductline(0, 'Null', 1);
    this.userForm.controls['teamid'].setValue(0);
    this.userForm.controls['singlesignon'].setValue(false);
    this.userForm.controls['userrole'].setValue(0);
    this._selectedProductLineItemsTmp=[];
    if(this.isautologadmin==1 || this.isautologteam==this.AdminTeamId)
{
  this.hideChkAutoAdminAcs=false;
}
else
{
  this.hideChkAutoAdminAcs=true;
}
    //$('body').addClass('nav-sm').removeClass('nav-md');
  }

  singlesignon(eve) {
    
    if (eve.target.value = 0) {
      this._hidepassword = 1;
    }
    else {
      this._hidepassword = 0;
    }

  }
  ngAfterViewInit() {
    
    this._userId = +this.route.snapshot.queryParamMap.get('userid');
    if (this._userId > 0 ) {
      this._selectedItems = [];
      this._requestselectedItems = [];
      this._selectedReviewItems = [];
      this.edituser(this._userId);    
      this._action = 'update';
      this.title = "Update ";
    }
    else {
      this._action = 'add';
      this.title = "Add ";
    }
    this.cdref.detectChanges();

  }

  get formdata() { return this.userForm.controls; }

  onFileSelect(fileInput: any) {
    if (fileInput.target.files.length > 0) {
      this.fileselect = true;
      const file = fileInput.target.files[0];
      this.userForm.get('ImgFile').setValue(file);
      var reader = new FileReader();
      reader.readAsDataURL(fileInput.target.files[0]);
      reader.onload = (_event) => {
        this.imagepath = reader.result;
      }


    }
  }

  getimageedit(filename: string): any {

    this.UseraddService.GetImage(filename).subscribe(res => {
      if (res.type != 'text/plain') {
        let objectURL = 'data:image/jpeg;base64,' + res.image;
        this.imagepath = this._sanitizer.bypassSecurityTrustUrl(objectURL);
      }

    }, error => { });

  }
  changeUserType() {

   // var a = $("#userType option:selected").text();
    //if (a === "SSO User") {
    var a = $("#userType").prop('checked')
    if (a === true) {
      document.getElementById("password").style.display = "none"
    }
    else {
      // this.userType = true;
      // this.userType = true;

      if (this.edituser1 != null) {
        if (this.edituser1.passwordhash != null)
          document.getElementById("password").style.display = "none"
        else
          document.getElementById("password").style.display = "block"
      }
      else
        document.getElementById("password").style.display = "block"



    }
  }

  Postuser(user: User) {

    this.submitted = true;
    let a= new encryptdecrypt(); 
    if (this.userForm.valid) {
      //this.useridlogin = +localStorage.getItem('userid');
      this.useridlogin = +this.localService.getJsonValue('userid');
      var groupDatabaseMapped = {};
      var grouprequestmapped = {};
      var groupreviewrequestmapped = {};
    
      if (this.userForm.value.singlesignon == false)
        user.singlesignon = 1;
      else
        user.singlesignon = 2;

      if(this._action!='update'){
      if (user.password == "" && user.singlesignon == 1) {
        this.toastr.error('Password should be entered for local user');
        return;
      }
    }

      //if (user.singlesignon == 0) {

      //  this.toastr.error('User type should get selected');
      //  return;
      //}

     
      if (user.teamid == 0 )//&& this.autoLogAccess !=1
       {

        this.toastr.error('Team should get selected');
        return;
      }
      if (user.singlesignon == 2) {
        user.password = 'password';
      }

      if (user.singlesignon != 2 && +this.passwordComplexity <=69  && this._action=='add'){
      
          this.toastr.error("Please use complex password");
          return;
      
      }

      if (user.userrole == "0" ) {//&& this.autoLogAccess !=1
        this.toastr.error('User role should get selected');
        return;
      }
    
      if (user.teamid == this.autologUserTeamId && user.userrole == "1")//&& this.autoLogAccess !=1
      {
debugger
       this.toastr.error('Please change the user role');
       return;
     }

      if (this._selectedItems.length == 0 && this.autoLogAccess ==0 ) {
        this.toastr.error('Atleast any one database should get selected');
        return;
      }

 //if (this._requestselectedItems.length == 0) {
 //       this.toastr.error('Atleast any one Request should get selected');
 //       return;
 //     }
      //if (this.menucomp.actionArray.length == 0) {
      //  this.toastr.error('Atleast one menus with required rights should get selected');
      //  return;
      //}
      this.checkedstatus = this.menucomp.getselectedmenuscheck();

      if (this.checkedstatus == false && this.autoLogAccess !=1) {
        this.toastr.error('Atleast one menus with required rights should get selected');
        return;
      }   

      if (this._action == 'update' && this.edituser1.active ==0) {
        this.toastr.error('User should be active to edit');
        return;
      }   
    

    user.emailid=a.encryptUsingAES256(user.emailid.toString());
    user.password=a.encryptUsingAES256(user.password.toString());
    user.firstname=a.encryptUsingAES256(user.firstname.toString());
    user.lastname=a.encryptUsingAES256(user.lastname.toString());
    if((this._action=='update') && (this.edituser1.teamid != this.autologUserTeamId)
    &&  (this.edituser1.autologinputstr == null)  && (this._selectedProductLineItems.length >0) && 
    (this.autoLogAccess==0)){
      this.autoLogAccess=2;
    }
      if((this.autoLogAdmin === true || this.autoLogAccess !==  0) && this._action=='update'&& 
      this.edituser1.autologinputstr == null  && this._selectedProductLineItems.length >0){
        this.isAutologNewuser=true;
        this.isautologuser=true;
      }

      if((this.autoLogAdmin === true || this.autoLogAccess !==  0) && this._action=='add'&& 
      this.edituser1 == undefined ){
        this.isAutologNewuser=true;
        this.isautologuser=true;
      }

      if((this.autoLogAdmin === true || this.autoLogAccess !==  0) && 
      (this._selectedProductLineItems.length ==0) && this.isAutologNewuser==true){
          this.toastr.error('Atleast one Product Line details required for the Auto Log Authentication');
          return;
          }

          if((this.autoLogAdmin === true || this.autoLogAccess !==  0) && 
          (this._selectedProductLineItems.length ==0) && this.isAutologNewuser==false &&  this.isautologuser==true){
              this.toastr.error('Atleast one Product Line details required for the Auto Log Authentication');
              return;
              }

          if(this._selectedProductLineItems.length>0 &&  
            this._selectedProductLineItems.length!=1  && ( this.isAutologNewuser==true||this.isAutologNewuser==false)){
              let isdefault =this._selectedProductLineItems.filter(e=>e.isdefault==1);
            if(isdefault.length>1 || isdefault.length<1){
           this.toastr.error('Atleast one Product Line should be selected as defalut');
           return;
          }
          }

              if(this._selectedProductLineItems.length>0  && (this.isAutologNewuser==true||this.isAutologNewuser==false )){
                   if(this.autoLogAdmin === true)
                    user.isautologadmin=1;
                    else
                    user.isautologadmin=0;
                    if(this.autoLogAccess==0)
                    user.isautologuseronly=2;
                    else
                    user.isautologuseronly=this.autoLogAccess;
                    user.autologinputstr=JSON.stringify(this._selectedProductLineItems);
                    user.singlesignon = 1;
    //form the input json string for autolog save user api call
      this.apiautologinputstr= JSON.stringify(this.forminpjsonsaveautolog(this._action,this._selectedProductLineItems,a.decryptUsingAES256(user.emailid.toString())));
      }
      else {
        if(this.isAutologNewuser==false && this.isautologuser==true){
         this.apiautologinputstr= JSON.stringify(this.forminpjsonsaveautolog(this._action,this._selectedProductLineItems,a.decryptUsingAES256(user.emailid.toString())));
        }
       
          user.autologinputstr='';
          user.isautologuseronly=0;
          user.isautologadmin=0;
       
       
        }

      if(this.apiautologinputstr!=''){
        user.apiautologinputstr=this.apiautologinputstr;
        }
      if(this._action=='update'){
       user.isautologuser=this.isautologuser;
        }

      //forming the menu with the required actions list


      //
      //if (this.menucomp.actionArray.length != 0) {
      this._mappedMenuActionList = [];
      //  this.menucomp._menuList.forEach(item => {
      //    var selected = [];
      //    this.menucomp.actionArray.forEach(a => {
      //      if (item.data.menuid == a.menuid) {
      //        selected.push(a.action)
      //      }
      //    });
      //    this._mappedMenuActionList.push({
      //      'menuid': item.data.menuid,
      //      'action': selected
      //    });
      //  });

      //}

      this._mappedMenuActionList = this.menucomp.getselectedmenus();      
      user.menumapped = JSON.stringify(this._mappedMenuActionList);

      groupDatabaseMapped['databasemapped'] = this.databaseSaveStructure(this._selectedItems);

      user.databasemapped = JSON.stringify(groupDatabaseMapped);


      groupreviewrequestmapped['reviewmapped'] = this.requestSaveStructure(this._selectedReviewItems);
      user.reviewmapped = JSON.stringify(groupreviewrequestmapped);


      grouprequestmapped['requestmapped'] = this.requestSaveStructure(this._requestselectedItems);

      user.requestmapped = JSON.stringify(grouprequestmapped);
      
      var userrole = $("#userrole option:selected").text();
      user.userrole = userrole;
      user.autologapitoken=this.localService.getJsonValue('apitoken');
      if (this._action == 'add') {
		 this.SpinnerService.show();						   
        user.userid = 0;
        user.createdby = this.useridlogin;
        user.active = 1;
        const formData = new FormData();
        formData.set('ImgFile', this.userForm.get('ImgFile').value);
        for (var key in user) {
          formData.set(key, user[key]);
        }
        
        this.commonService.sendemail(user.emailid, "useradd").toPromise().then(res => {
          this.UseraddService.Post(formData).subscribe(
            (res) => {
              console.log(res);
              if (res.body != 0) {
                this.toastr.success('User added successfully');
                this.router.navigate(['/home/usermgt']);
                this.clearForm();
                this.SpinnerService.hide();	
                if(this.apiautologinputstr!=''){
                var inputstr={};
                inputstr['p_eventname'] =this._action,
                inputstr['p_userid'] =res.body,
                inputstr['p_isautologadmin']=user.isautologadmin,
                inputstr['p_isautologuseronly'] =user.isautologuseronly,
                inputstr['p_inputjson']=JSON.parse(this.apiautologinputstr)
 
                  }

              }
              else {
                this.toastr.warning('User already exists ');
                this.SpinnerService.hide();
              }
            }, error => {
              this.toastr.error(error.error);
              this.SpinnerService.hide();
            });
        },
          error => {
			 this.SpinnerService.hide();						   
            this.toastr.error(error.error );
            return;
          });
      }

      //updating the user information
      if (this._action == 'update') {
		this.SpinnerService.show();						   
        user.modifiedby = this.useridlogin;
        user.userid = this._userId;
        if (this.edituser1 != null) {
          user.accessrequestid = this.edituser1.accessrequestid;
        }
        const formData = new FormData();
        formData.set('ImgFile', this.userForm.get('ImgFile').value);
        for (var key in user) {
          formData.set(key, user[key]);
        }

        this.UseraddService.Put(formData).subscribe(
          (res) => {
            if (res.body != 0) {
              this.toastr.success('User updated successfully');
              this.router.navigate(['/home/usermgt']);
              this.clearForm();
              this.SpinnerService.hide();		
            }
            else {
              this.toastr.warning('User already exists');
              this.SpinnerService.hide();}
          }, error => {
			this.SpinnerService.hide();						   
            this.toastr.error(error.error);

          });
      }


    }

  }
  //form save json structure for database
  databaseSaveStructure(list) {
    var temp = [];
    if (list.length > 0) {
      list.forEach(item => {
        temp.push({ databaseid: item.databaseid })
      })
    }
    return temp;
  }

  requestSaveStructure(list) {
    var temp = [];
    if (list.length > 0) {
      list.forEach(item => {
        temp.push({ requesttypeid: item.requesttypeid })
      })
    }
    return temp;
  }

  clearForm() {

    this.submitted = false;
    this._selectedItems = [];
    this.userForm.controls['databasemapped'].setValue(this._selectedItems);   
    this._selectedReviewItems = [];
    this.userForm.controls['reviewmapped'].setValue(this._selectedReviewItems);
    this._requestselectedItems = [];
    this.userForm.controls['requestmapped'].setValue(this._requestselectedItems);
    this.userForm.reset();
    //this._action = '';
    this.userForm.controls['teamid'].setValue(0);
    this.userForm.controls['singlesignon'].setValue(false);
    this.menucomp.reset();
    this._selectedProductLineItems=[];
    this.selectedProductLineItems=[];
    this._selectedProductLineItemsTmp=[];
    this.autoLogAccess=0;
    this.autoLogAdmin=false;
    if (this._action == 'update') {
      this.router.navigate(['home/usermgt']);
    }

  }

  LoadExisitingTeamList() {
    this.teamService.Get().subscribe(res => {
      var allData = res;
      if(this.isLoggedUsrAutLog==1){
     var autologTeam=allData.filter(e=>e.teammgtid==this.autologUserTeamId);
     if(autologTeam!=undefined && autologTeam.length >0){
      this._teamListTmp.push({ teamid: autologTeam[0]['teammgtid'], team: autologTeam[0]['teammgt'] });
     }else
     {
      this._teamListTmp=[];
     }
      }else{
      allData.forEach(data => {
        if (data.active != 0) {
          this._teamListTmp.push({ teamid: data.teammgtid, team: data.teammgt })
        }
      });
    }
      this._teamList = JSON.parse(JSON.stringify(this._teamListTmp));
      console.log(this._teamList);
    }, error => { this.toastr.error('error while getting Data'); });
  }

  //dropdown changed event
  changeteam(eve) {
    if (eve.target.value > 0) {
      this.teamService.Get().subscribe(
        (res) => {
          this.teams = res;
          this.team = this.teams.find(r => r.teammgtid == eve.target.value);

          if (res != undefined) {
            if (JSON.parse(this.team.databasemapped) != null)
             // this._selectedItems = (JSON.parse(this.team.databasemapped)).databasemapped;
              this._selectedItems = this.formMultiSelectStrucuture((JSON.parse(this.team.databasemapped)).databasemapped, this._databaseListTmp);
            else
              this._selectedItems = [];

            this.menucomp.reset();
            this.menucomp.teamchange(this.team.teammgtid);
            if (JSON.parse(this.team.requestmapped) != null)
              this._requestselectedItems = this.requestMultiSelectStrucuture((JSON.parse(this.team.requestmapped)).requestmapped, this._requestListTmp);
            else
              this._requestselectedItems = [];
              if(eve.target.value == this.autologUserTeamId ){
                this.hideChkAutoAccess=true;
                this.autoLogAccess=1;
                              
               // this.isLoggedUsrAutLog=1
              }
              else{
                this.hideChkAutoAccess=false;
               
                this.autoLogAccess=0;
              }
          }
        }, error => {
          //console.log(error);
        });
    }
  }

  LoadExisitingDatabaseList() {
    this.databaseService.Get().toPromise().then(res => {
      var allData = res;
      this._databaseListTmp = [];
      allData.forEach(data => {
        if (data.active != 0) {
          this._databaseListTmp.push({ databaseid: data.databaseid, database: data.database })
        }
      });
      this._databaseList = [];
      this._dropdownSettings = {
        singleSelection: false,
        idField: 'databaseid',
        textField: 'database',
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',
        itemsShowLimit: 7,
        allowSearchFilter: true
      };
      this._databaseList = JSON.parse(JSON.stringify(this._databaseListTmp));
      if (this.edituser1 != null) {
        if (this._databaseListTmp.length > 0) {
          if (JSON.parse(this.edituser1.databasemapped) != null)
            this._selectedItems = this.formMultiSelectStrucuture((JSON.parse(this.edituser1.databasemapped)).databasemapped, this._databaseListTmp);
          else
            this._selectedItems = [];
        }
      }
    }, error => { this.toastr.error('error while getting Data'); });
  }



  LoadExisitingRequestTypeList() {
    this.UseraddService.GetRequesttype().toPromise().then(res => {
      var allData = res;
      this._requestListTmp = [];
      allData.forEach(data => {
        if (data.active != 0) {
          this._requestListTmp.push({ requesttypeid: data.requesttypeid, requesttype: data.requesttype })
        }
      });
      this._requestList = [];
      this._requestdropdownSettings = {
        singleSelection: false,
        idField: 'requesttypeid',
        textField: 'requesttype',
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',
        itemsShowLimit: 7,
        allowSearchFilter: true
      };
      this._requestreviewdropdownSettings = {
        singleSelection: false,
        idField: 'requesttypeid',
        textField: 'requesttype',
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',
        itemsShowLimit: 7,
        allowSearchFilter: true
      };
      this._requestList = JSON.parse(JSON.stringify(this._requestListTmp));
      this._requestReviewList = JSON.parse(JSON.stringify(this._requestListTmp));
      if (this.edituser1 != null) {
        if (this._requestListTmp.length > 0) {
          if (JSON.parse(this.edituser1.requestmapped) != null)
            this._requestselectedItems = this.requestMultiSelectStrucuture((JSON.parse(this.edituser1.requestmapped)).requestmapped, this._requestListTmp);
          else
            this._requestselectedItems = [];

          if (JSON.parse(this.edituser1.reviewmapped) != null) {
            this._selectedReviewItems = this.requestMultiSelectStrucuture((JSON.parse(this.edituser1.reviewmapped)).reviewmapped, this._requestListTmp);
          } else {
            this._selectedReviewItems = [];
          }

        }
      }
    }, error => { this.toastr.error('error while getting Request type Data'); });
  }


  chkArrayTouched() {
    this.textBoxTocuhed = true;
  }


  Backtouserlist() {
    
    if ((this.edituser1 != null) && ((this.userForm.touched == true) || (this.textBoxTocuhed == true) || (this.fileselect==true))) {
      this.confirmation(this.edituser1.userid);

    }
    else {
      this.router.navigate(['/home/usermgt']);     
    }
  }

  confirmation(userid) {
    let showpopup = this.dialogService.addDialog(CommondialogComponent,
      {
        title: 'Confirmation',
        message: 'Would you like to save changes? ',
        hclass: 'modelsuccess',
        oktext: 'Yes',
        canceltext: 'No',
        okshow: true,
        cancelshow: true
      }).subscribe((isConfirmed) => {
        if (isConfirmed) {
          this.Postuser(this.userForm.value);
        }
        else {
          this.router.navigate(['/home/usermgt']);                      
        }
      });

  }
  //form valid mail structure suit for  multi select list
  formMultiSelectStrucuture(mappedList, dbList) {
    var tempList = [];
    if (mappedList.length != 0) {
      dbList.forEach((d) => {
        mappedList.forEach((data, ind) => {
          if (data.databaseid == d.databaseid) {
            tempList.push({
              databaseid: d.databaseid, database: d.database
            });
          }
        });
      });
    }
    mappedList = [];
    mappedList = tempList;
    return tempList;
  }


  //form valid mail structure suit for  multi select list
  requestMultiSelectStrucuture(mappedList, requestList) {
    var tempList = [];
    if (mappedList.length != 0) {
      requestList.forEach((d) => {
        mappedList.forEach((data, ind) => {
          if (data.requesttypeid == d.requesttypeid) {
            tempList.push({
              requesttypeid: d.requesttypeid, requesttype: d.requesttype
            });
          }
        });
      });
    }
    mappedList = [];
    mappedList = tempList;
    return tempList;
  }




  //click event for edit icon in the grid
  edituser(userid) {
    //this.LoadExisitingDatabaseList();
    this._action = 'update';
    this.userForm.value.userid = userid;
    this.userForm.value.databasemapped = '';
let a= new encryptdecrypt(); 
      
    this.UseraddService.GetById(userid).subscribe(
      (res) => {
        console.log(res);
        res.forEach((data: any) => {
        data.firstname = a.decryptUsingAES256(data.firstname);
        data.lastname = a.decryptUsingAES256(data.lastname);
        data.emailid = a.decryptUsingAES256(data.emailid);
      });
        this.users = res;
        this.edituser1 = this.users.find(y => y.userid == userid);
             
//autolog details
debugger
if(this.edituser1.autologinputstr != null && this.edituser1.autologinputstr !=undefined && 
  this.edituser1.autologinputstr !=''){
    this.isAutologNewuser=false;
  }

if(this.edituser1.isautologadmin==1)
this.autoLogAdmin = true;
else
this.autoLogAdmin = false;
if( this.chkautoLogAccess==false){
  this.autoLogAccess=this.edituser1.isautologuseronly;
}
if(this.edituser1.teamid==this.autologUserTeamId){
  this.hideChkAutoAccess=true;
  this.autoLogAccess=1;
}
else
{
  this.hideChkAutoAccess=false;
}
//disablng the autolog admin checkbox
debugger
if(this.isautologadmin==1 || this.isautologteam==this.AdminTeamId)
{
  this.hideChkAutoAdminAcs=false;
}
else
{
  this.hideChkAutoAdminAcs=true;
}
        $("#userrole option:contains(" + this.edituser1.userrole + ")").attr('selected', 'selected');

        // var userval = $("#userrole").val(this.edituser1.userrole);
        var userval = $("#userrole option:selected").val();
        this.userForm.controls['userrole'].setValue(userval);

      
        this.userForm.controls['userid'].setValue(this.edituser1.userid);
        this.userForm.controls['firstname'].setValue(this.edituser1.firstname);
        this.userForm.controls['lastname'].setValue(this.edituser1.lastname);
        this.userForm.controls['emailid'].setValue(this.edituser1.emailid);
      
        this.userForm.controls['teamid'].setValue(this.edituser1.teamid);

        if (this.edituser1.singlesignon == 1)
          this.userForm.controls['singlesignon'].setValue(false);
        else if (this.edituser1.singlesignon == 2)
          this.userForm.controls['singlesignon'].setValue(true);

       // this.userForm.controls['singlesignon'].setValue(this.edituser1.singlesignon);
       // this.userForm.controls['userrole'].setValue(this.edituser1.roleid);

        if (this.edituser1.singlesignon === 2) {
          document.getElementById("password").style.display = "none"
        }
        else {
          // this.userType = true;
          if (this.edituser1.passwordhash != null)
            document.getElementById("password").style.display = "none"
          else
            document.getElementById("password").style.display = "block"
        }

        this.userForm.controls['password'].setValue(this.edituser1.password);
        if (this.edituser1.profileimagepath != null) {
          this.imagepath = this.getimageedit(this.edituser1.profileimagepath);

        }
        if (this.edituser1.accessrequestid != null) {
          this._accessrequestid = this.edituser1.accessrequestid;

          this.userForm.controls['comment'].setValue(this.edituser1.comment);
        }
        //this.menucomp.edituser(this.edituser1.menumapped);      
        this.LoadExisitingDatabaseList();     
        this.LoadExisitingRequestTypeList();
        this.loadproductline(0, 'Null', 1);
this.SpinnerService.hide();

      }, error => {
		this.SpinnerService.hide();						   
        //console.log(error);
      });




  }



  OnItemDeSelect(item:any){
    let index = this._selectedProductLineItems.findIndex(x => x.productlineid ===item.productlineid);
    if (index > -1) {
      this._selectedProductLineItems.splice(index, 1);
    }
    if(this._selectedProductLineItems.length==0){
      this.autoLogAccess=0;
    }
  }
 

  removeProductLine(item){
    debugger
    console.log(item);
    let index = this._selectedProductLineItems.findIndex(x => x.productlineid ===item.productlineid);
    if (index > -1) {
      this._selectedProductLineItems.splice(index, 1);
    }
    this.selectedProductLineItems=this.productlineMultiSelectStrucuture(this._selectedProductLineItems,this.productline);
    if(this._selectedProductLineItems.length==0){
      this.autoLogAccess=0;
    } 
  }
  onItemSelect(item: any) { 
    var a=this._selectedProductLineItems.filter(e=>e.productlineid==item.productlineid);
    if(a.length==0){
      this._selectedProductLineItems.push({'productlineid':item.productlineid,'name':item.name,
      'role':'User','isdefault':0});
    }
    else{
      let index = this._selectedProductLineItems.findIndex(x => x.productlineid ===item.productlineid);
      this._selectedProductLineItems[index]['role']=a[0]['role'];
      this._selectedProductLineItems[index]['isdefault']=a[0]['isdefault'];
    }
  //  this.autoLogAccess=0;
    console.log(this._selectedProductLineItems);
 }

 onSelectAll(item: any){
   debugger
  // if(this._selectedProductLineItems.length>0){
    item.forEach(element => {
      var a=this._selectedProductLineItems.filter(e=>e.productlineid==element.productlineid);
    if(a.length==0){
      this._selectedProductLineItems.push({'productlineid':element.productlineid,'name':element.name,
      'role':'User','isdefault':0});
    }
    else{
      let index = this._selectedProductLineItems.findIndex(x => x.productlineid ===element.productlineid);
      this._selectedProductLineItems[index]['role']=a[0]['role'];
      this._selectedProductLineItems[index]['isdefault']=a[0]['isdefault'];
    } 
    });  
  // }
  
    console.log(this._selectedProductLineItems);
  // }); //need to change in dev

 }
 selectAutoLogRights(eve,ind){
  this._selectedProductLineItems[ind]['role']=eve.target.value;
   console.log(this._selectedProductLineItems);
 }

 selectAutoLogdefault(eve,ind){
   this._selectedProductLineItems.forEach((ele) => {
     ele.isdefault=0;
   });
  this._selectedProductLineItems[ind]['isdefault']=1;
  console.log(this._selectedProductLineItems);
 }
selautologonly(event){
  this.chkautoLogAccess = true;
  if(event.target.checked){    
    this.autoLogAccess=1;
    this._selectedItems = [];
    this.userForm.controls['databasemapped'].setValue(this._selectedItems); 
   // this.userForm.controls['teamid'].setValue(0);
  //  this.userForm.controls['userrole'].setValue(0);
    this._selectedReviewItems = [];
    this.userForm.controls['reviewmapped'].setValue(this._selectedReviewItems);
    this._requestselectedItems = [];
  //  this.userForm.controls['requestmapped'].setValue(this._requestselectedItems);
  //  this.menucomp.reset();
   // $("#userrole").prop('disabled', 'true');
   // $("#teamid").prop('disabled', 'true');   
   
  } 
  else{
    if(this._userId>0){
   this.edituser(this._userId); 
   var len=$("#userrole option").length;    
   var index=0;
  // this.menucomp.reset();
   for(var i=0;i<=len-1;i++){
     if($("#userrole option")[i].innerText==this.edituser1.userrole){
      index=i;
     }
   }
   $("#userrole option")[index].selected=true;
  // this.userForm.controls['userrole'].setValue(this.edituser1.userrole);
 
  this._userId = +this.route.snapshot.queryParamMap.get('userid');
 //// this.menucomp.parentuserid=this._userId ;
  //this.menucomp.loadmenu();
 }
  this.autoLogAccess=2;   
 // $('#userrole').removeAttr('disabled');
 // $('#teamid').removeAttr('disabled');
 
  }
 
}
selautologadmin(event){
  if(event.target.checked)
  this.autoLogAdmin=true;
  else
  this.autoLogAdmin=false;
}

loadproductline(productid, product, active) { 
  this.SpinnerService.show();
  let loggedUser=this.localService.getJsonValue("userid"); 
 // this.localService.setJsonValue('isautologteam', Login.teamid);
  this.formRenderService.LoadProductLine(productid, product, active).toPromise().then(
    (res) => {
      this.UseraddService.GetById(loggedUser).subscribe(
        (result) => {
          var usersLst=[];
          usersLst=result;
      var data=JSON.parse(res[0].j);
      this.productline=[];
      this.productline=data.map(i=>({productlineid:i.ProductLineID,name:i.Name})); 
       
      var loggedAutologUser=  usersLst.find(y => y.userid == loggedUser);
     if(this.isLoggedUsrAutLog!=0 && loggedAutologUser.isautologadmin!=1
     && loggedAutologUser.autologinputstr !=undefined && loggedAutologUser.autologinputstr!=''){
      var prdLineList=  JSON.parse(loggedAutologUser.autologinputstr);
      var isPrdLineAdminLst= prdLineList.filter(y=>y.role=='Admin');
      this.productline=[];
      if(isPrdLineAdminLst!=undefined && isPrdLineAdminLst.length>0)
      {
        this.productline=isPrdLineAdminLst.map(i=>({productlineid:i.productlineid,name:i.name})); 
      }   
    }  
      if(this.AdminTeamId==this.isautologteam && this.isLoggedUsrAutLog==0
       && loggedAutologUser.isautologadmin!=1 &&
        (loggedAutologUser.autologinputstr !=undefined || loggedAutologUser.autologinputstr!='')) {
      this.productline=[];
     // this.productline=data.map(i=>({productlineid:i.ProductLineID,name:i.Name})); 
    }


    if(this.AdminTeamId!=this.isautologteam && this.isLoggedUsrAutLog==0
      && loggedAutologUser.isautologadmin!=1 &&
       (loggedAutologUser.autologinputstr !=undefined || loggedAutologUser.autologinputstr!='')) {
     this.productline=[];
    // this.productline=data.map(i=>({productlineid:i.ProductLineID,name:i.Name})); 
   }
      this._prodDropdownSettings = {
        singleSelection: false,
        idField: 'productlineid',
        textField: 'name',
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',
        itemsShowLimit: 7,
        allowSearchFilter: true,
      };
     // this.selectedProductLineItems = JSON.parse(JSON.stringify(tmp));
if(this.edituser1 !=null){
if(this.edituser1.autologinputstr != null && this.edituser1.autologinputstr !=undefined && 
  this.edituser1.autologinputstr !='')
  this._selectedProductLineItems=JSON.parse(this.edituser1.autologinputstr);
  else
  this._selectedProductLineItems=[];

if(this._selectedProductLineItems.length>0)
this.isautologuser=true;
this.selectedProductLineItems=this.productlineMultiSelectStrucuture(this._selectedProductLineItems,this.productline);
}
        });

       this.SpinnerService.hide();
    },      
    error => {
     
      this.SpinnerService.hide();
    });
  
  
}
/*onSelectAll(item: any){
  //console.log(item);
  item.forEach(element => {
    if(this._selectedProductLineItems.length>0){
      var a=this._selectedProductLineItems.filter(e=>e.productlineid==item.productlineid);
      if(a.length==0){
        this._selectedProductLineItems.push({'productlineid':element.productlineid,'name':element.name,
        'role':'User','isdefault':0});
      }
      else{
        let index = this._selectedProductLineItems.findIndex(x => x.productlineid ===element.productlineid);
        this._selectedProductLineItems[index]['role']='User';
        this._selectedProductLineItems[index]['isdefault']=0;
      }
    }else{
      this._selectedProductLineItems.push({'productlineid':element.productlineid,'name':element.name,
      'role':'User','isdefault':0});
    }
  });


 
//  this.autoLogAccess=0;
  console.log(this._selectedProductLineItems);


}*/

onDeSelectAll(eve){
  this._selectedProductLineItems=[];
  if(this._selectedProductLineItems.length==0){
    this.autoLogAccess=0;
  }
  //this.autoLogAccess=0;
}

productlineMultiSelectStrucuture(mappedList, productLinelist) {
  var tempList = [];
  if (mappedList.length != 0) {
    productLinelist.forEach((d) => {
      mappedList.forEach((data, ind) => {
        if (data.productlineid == d.productlineid) {
          tempList.push({
            productlineid: d.productlineid, name: d.name
          });
        }
      });
    });
  }
  mappedList = [];
  mappedList = tempList;
  return tempList;
}


//get the input json string

forminpjsonsaveautolog(action,selectedList,userEmailId){
  var input={}; let defaultProductLine='';let roles=[];
 let loggedusremail= this.localService.getJsonValue('emailid');
 if(this.isAutologNewuser==false && selectedList.length ==0){
  input['loginId']=userEmailId; 
  input['changedBy']=loggedusremail;//this.autologAdminId; 
 }
 else{
   if(this._selectedProductLineItems.length==1){
    defaultProductLine=this._selectedProductLineItems[0].productlineid;
   }else{
  let _default = this._selectedProductLineItems.find(x => x.isdefault ==1);
if(_default!=null && _default!=undefined){
  defaultProductLine=_default.productlineid;
}
}
roles= this._selectedProductLineItems.map(i=>({type:i.name+"-"+i.role}));
//Admin

let adminrights=this._selectedProductLineItems.filter(i=>i.role=='Admin');
if(adminrights!=undefined && adminrights.length>0){
  adminrights.forEach(ele => {
    roles.push({'type':ele.name+"-User"})
  });
}
  if(this.autoLogAdmin==true){
    roles.push({'type':'Admin'});
  }
  input['loginId']=userEmailId;
  input['defaultProdLineId']=defaultProductLine;
  input['changedBy']=loggedusremail;//this.autologAdminId;
  input['roles']=roles;
  if(action=='add'){
    input['isNewUser']=true;
  }else{
    if(this.isAutologNewuser== true)
    input['isNewUser']=true;
    if(this.isAutologNewuser== false)
    input['isNewUser']=false;
  }  
 }
  return input;
}

isFoundPrdLine(product:any){
  
  var ind= this.productline.filter(x=> x.productlineid == product.productlineid);
  if(ind!=undefined && ind.length>0)
return 1;
else
return 0;
}


getfrmValue($event) {  
   
  this.passwordComplexity = $event;
    }
}

